import { SpotlightDocumentSchema } from "@redotech/redo-model/spotlight-document-schema";
import { SpotlightFormSchema } from "@redotech/redo-model/spotlight-schema";
import * as z from "zod/v4";

export const createSpotlight = {
  name: "createSpotlight" as const,
  input: z.object({ form: SpotlightFormSchema }),
  output: z.object({ spotlight: SpotlightDocumentSchema }),
};
